import React, { useState, useEffect, useRef, memo } from "react";
import { Panel } from "primereact/panel";
import { Toast } from "primereact/toast";
import { UseMedia } from '../Funciones'
import DataTable1 from "../Home/Indicadores/DetalleTipoActividad/DataTable1";
import Chart1 from "../Home/Indicadores/DetalleTipoActividad/Chart1";
import Services from "../../service/Services";
import Cookies from 'universal-cookie';
import axios from "axios";
const cookies = new Cookies();

const Block5 = memo(({ dateStartDBProp, dateEndDBProp, getProjectsProp, setChartDataProp, setDataOfficialProp, individualMonthReportProp, readReportProp, userSelectedProp,
    setDataUserProp, monthlyReportProp, listReportsUsersProp, projectsUserSessionProp, setClients, setLoadingProp }) => {

    const [dataFuncionariosTable, setDatafuncionariosTable] = useState([]);
    const [funcionarioSelected, setFuncionarioSelected] = useState("");

    const getService = new Services();

    const userDocSession = cookies.get('numeroDocumento')
    const [previousValue, setPreviousValue] = useState(null);
    const getPrincipalData = (dateStartDBProp, dateEndDBProp, getProjectsProp, document, informeOtroFuncionario, servicioTipoNovedad) => {
        var projectClient = []
        let result = []
        if (informeOtroFuncionario === true) {
            const result = getProjectsProp.filter(item => {
                const idClient = parseInt(item.proyecto.cliente.id)
                return idClient === setClients.id
            })
            result.forEach(element => {
                var selectedProject = {}
                selectedProject.id = element.proyecto.id
                selectedProject.nombre = element.proyecto.nombreproyecto
                selectedProject.fechainiciovigencia = element.fechainiciovigencia
                selectedProject.fechafinvigencia = element.fechafinvigencia
                projectClient.push(selectedProject)

            });
        } else {
            result = getProjectsProp.filter(function (object) {
                var idClient = parseInt(object.cliente.id)
                return idClient === setClients.id
            })
            result.forEach(element => {
                var selectedProject = {}
                selectedProject.id = element.id
                selectedProject.nombre = element.nombre
                selectedProject.fechainiciovigencia = element.fechainiciovigencia
                selectedProject.fechafinvigencia = element.fechafinvigencia
                projectClient.push(selectedProject)

            });
        }

        projectClient.sort(function (a, b) {
            var textA = a.nombre;
            var textB = b.nombre;
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        var newGetProjectsProp = projectClient.map(item => {
            return parseInt(item.id)
        })

        const data = {
            fecFinal: dateEndDBProp,
            fecInicial: dateStartDBProp,
            idActividades: [],
            idCargo: [],
            idClientes: [],
            idEquipoTrabajo: [],
            idProyectos: newGetProjectsProp,
            idUsuarios: readReportProp ? document !== "" ? ["" + document + ""] : ["" + userDocSession + ""] : ["" + userDocSession + ""],
        };

        if (data.idProyectos.length !== 0) {
            setPreviousValue(data)
            if (JSON.stringify(previousValue) !== JSON.stringify(data)) {
                getService.dashboardTypeActivityProject(data).then((res) => {
                    if (res.status === 200) {


                        const newData = res.data.map(item => {
  
                                return {

                                    detalle: item.detalle.map(j => {

                                        return {
                                            categoria: j.categoria,
                                            horas: j.horas.toFixed(2),
                                            porcentajeHoras: j.porcentajeHoras,
                                            tipoActividad: j.tipoActividad,
                                        }
                                    }),
                                    horasNovedades: item.detalle.reduce((sum, z) => {
                                        servicioTipoNovedad.forEach(tp => {
                                            if (tp.tipoActividad.id === z.idTipoActividad) {
                                                sum += z?.horas || 0;
                                            }
                                        });
                                        return sum;
                                    }, 0),
                                    id: item.id,
                                    idproyecto: item.idproyecto,
                                    proyecto: item.proyecto,
                                    totalHoras: item.totalHoras.toFixed(2),
                                    totalHorasAdicionales: item.totalHorasAdicionales,
                                    totalPorcentaje: item.totalPorcentaje,
                                    usuario: item.usuario,
                                }
                            
                        })

                        setDatafuncionariosTable(newData);
                        if (setDataOfficialProp !== undefined) {
                            setDataOfficialProp(newData)
                        } else {
                            setDataOfficialProp([])
                        }
                        setLoadingProp(false)

                    } else {
                        
                        setDatafuncionariosTable([])

                    
                        setLoadingProp(false)
                    }
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }; // eslint-disable-next-line react-hooks/exhaustive-deps

    const toast = useRef(null);
    useEffect(() => {
        const source = axios.CancelToken.source();
    
        const fetchTipoNovedad = async () => {
            try {
                const data = await getService.getTipoNovedad();
                return data !== undefined ? data : [];
            } catch (error) {
                console.error("Error en fetchTipoNovedad", error);
                return [];
            }
        };
    
        const fetchUserData = async (id) => {
            try {
                const data = await getService.getUsuarios();
                return data !== undefined ? data.filter(object => parseInt(object.idUsuario) === parseInt(id)) : [];
            } catch (error) {
                console.error("Error en fetchUserData", error);
                return [];
            }
        };
    
        const fetchData = async () => {
            const tipoNovedad = await fetchTipoNovedad();
    
            if (dateStartDBProp && dateEndDBProp && projectsUserSessionProp.length !== 0) {
                if (readReportProp === true && (monthlyReportProp === 'monthlyReportOtherOfficial' || monthlyReportProp === 'allMonthlyReportOfOfficial') && userSelectedProp.id !== '') {
                    const userData = await fetchUserData(userSelectedProp.id);
    
                    if (userData.length !== 0 && tipoNovedad.length !== 0) {
                        getPrincipalData(dateStartDBProp, dateEndDBProp, userData[0].proyectos, userData[0].nrodocumento, true, tipoNovedad);
                    }
                } else {
                    let arrayProjects = [];
                    getProjectsProp.forEach(e => {
                        const filterProjects = projectsUserSessionProp.filter(obj => parseInt(obj.id) === parseInt(e.id));
                        arrayProjects = arrayProjects.concat(filterProjects);
                    });
    
                    if (arrayProjects.length !== 0 && tipoNovedad.length !== 0) {
                        getPrincipalData(dateStartDBProp, dateEndDBProp, arrayProjects, '', false, tipoNovedad);
                    }
                }
            }
        };

        if (dateStartDBProp && dateEndDBProp && (getProjectsProp.length > 0 || userSelectedProp.id !== '') && projectsUserSessionProp.length > 0) {
            fetchData();
        }
    
        return () => {
            if (source) {
                getService.cancelRequest();
            }
        };
    }, [dateStartDBProp, dateEndDBProp, getProjectsProp, projectsUserSessionProp, readReportProp, userSelectedProp, monthlyReportProp]); // eslint-disable-line react-hooks/exhaustive-deps

    const chartDataDummy = {
        labels: [],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    "#42A5F5",
                    "#66BB6A",
                    "#8500e7",
                    "#ffe601",
                    "#de880a",
                    "#42A5F5",
                    "#66BB6A",
                    "#8500e7",
                    "#ffe601",
                    "#de880a",
                    "#42A5F5",
                    "#66BB6A",
                    "#8500e7",
                    "#ffe601",
                    "#de880a",
                ],
                hoverBackgroundColor: ["#64B5F6", "#81C784", "#FFB74D"],
            },
        ],
    };

    const [chartData, setChartData] = useState(chartDataDummy);
    const [chartDataCategory, setChartDataCategory] = useState()

    let small = UseMedia("(max-width: 1450px)");

    return (
        <>
            <div className="p-grid">

                <Toast ref={toast} />
                <div className={small ? "p-col-12" : "p-col-6"}>
                    <Panel header="Tabla de datos">
                        {
                            <DataTable1
                                data={dataFuncionariosTable}
                                setDataChart={setChartData}
                                setChartDataProp={setChartDataProp}
                                dataChart={chartData}
                                setChartDataCategory={setChartDataCategory}
                                chartDataCategory={chartDataCategory}
                                setFuncionarioSelected={setFuncionarioSelected}
                                individualMonthReportProp={individualMonthReportProp}
                            />
                        }
                    </Panel>
                </div>
                <div className={small ? "p-col-12" : "p-col-6"}>
                    <Panel header={"Horas - Tipo actividad - " + funcionarioSelected}>
                        <Chart1 chartData={chartData} />
                    </Panel>
                </div>
            </div>
        </>
    )
})

export default Block5